import {MatrixClient} from 'matrix-js-sdk';

export const unignoreUser = (
  client: MatrixClient,
  userId: string
): Promise<void> => {
  const ignoredUsers = [...client.getIgnoredUsers()];
  const i = ignoredUsers.findIndex((u) => u === userId);
  if (i >= 0) {
    ignoredUsers.splice(i, 1);
  }
  return client.setIgnoredUsers(ignoredUsers).then(() => undefined);
};
